import { render } from "./MedicalDashboard.vue?vue&type=template&id=b500d59a&ts=true"
import script from "./MedicalDashboard.vue?vue&type=script&lang=ts"
export * from "./MedicalDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__